module.exports = __webpack_public_path__ + "img/status-bar-opened.03f45d20.svg";